import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { MyAccountPipelinesQuery, PipelineType } from '@/gql/graphql';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

const GetMyAccountPipelinesQuery = graphql(`
  query MyAccountPipelines($types: [PipelineType!]!) {
    me {
      user {
        account {
          pipelines(types: $types) {
            id
            publicId
            title
            colour
            type
            stages {
              id
              publicId
              title
              colour
              index
            }
          }
        }
      }
    }
  }
`);

const useGetMyAccountPipelines = ({
  types = ['STANDARD'],
  ...options
}: Partial<UseQueryOptions<MyAccountPipelinesQuery>> & {
  types?: PipelineType[];
} = {}) => {
  const { data, ...rest } = useQuery({
    staleTime: minutesToMilliseconds(5),
    ...options,
    queryKey: meKeys.accountPipelinesOfTypes(types),
    queryFn: () => {
      return gqlClient.request(GetMyAccountPipelinesQuery, { types });
    },
  });

  return { data: data?.me.user.account.pipelines, ...rest };
};

export default useGetMyAccountPipelines;
